const logo = new URL("./assets/flowisle.svg", import.meta.url).href;
export function FlowisleMark() { return <img className="flowisle-logo" src={logo} alt="" aria-hidden="true" width={36} height={36} />; }
